
const IS_FIREFOX = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
const IS_ANDROID = navigator.platform.toLowerCase().indexOf('android') > -1

export const BROWSER_CSS_ANIMATION = !!window.TransitionEvent
export const BROWSER_MOBILE = ('ontouchstart' in window) && !(IS_FIREFOX && !IS_ANDROID)
